export default __webpack_public_path__ + "static/media/Coin XS Stack Solid.8eb74bb8.png";